import { StyleSheet } from 'react-native'

export const TimeslotIconStyles = StyleSheet.create({
	iconWithSubIcons: {
		marginTop: 10
	},
	subIconContainer: {
		position: 'absolute',
		top: 3,
		left: 4,
		right: 4,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center'
	},
	secondarySubIcon: {
		marginRight: 4
	}
});